<template>
  <el-card v-if="isShow" v-loading="loading" class="bulletin">
    <div class="propject_detail_info_close_btn" @click="isShow = false"><i class="el-icon-error" /></div>
    <div slot="header">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="showAddBulletin({ 公司: companyName })">
        创建情报
      </div>
    </div>
    <bulletinTransferCards ref="bulletinTransferCards" :company="companyName"></bulletinTransferCards>
    <el-tabs v-model="bulletinsType">
      <el-tab-pane label="变动信息" name="transfer"> </el-tab-pane>
      <el-tab-pane label="招聘信息" name="bd"> </el-tab-pane>
    </el-tabs>
    <div style="margin: 15px;">
      <bulletinList
        :bulletins-type="bulletinsType"
        :bulletin-data="bulletinData"
        :handle-edit="showAddBulletin"
      ></bulletinList>
    </div>
    <bulletinAdd ref="bulletinAdd" :handle-save="handleSave" :handle-update="handleUpdate"></bulletinAdd>
  </el-card>
</template>
<script>
import bulletinTransferCards from './bulletinTransferCards'
import bulletinList from '../../../misc/src/bulletin/bulletinList'
import bulletinAdd from '../../../misc/src/bulletin/bulletinAdd'

export default {
  components: { bulletinTransferCards, bulletinList, bulletinAdd },
  props: {
    companyName: { type: String, default: '' },
  },
  data() {
    return {
      company: {},
      bulletinType: '情报',
      isShow: false,
      loading: false,
      bulletinData: [],
      bulletinsType: 'transfer',
    }
  },
  watch: {
    companyName(newValue, oldValue) {
      if (newValue) {
        this.loadBulletins()
      }
    },
  },
  methods: {
    open() {
      this.isShow = true
    },
    loadBulletins: async function() {
      this.bulletinData = []
      this.loading = true
      const option = { type: this.bulletinsType, 公司: this.companyName }
      const res = await app.service('misc').listBulletins(option)
      if (res.status === 'success') {
        this.bulletinData = res.data
      } else {
        this.$message.error(res.msg)
      }
      this.loading = false
    },
    handleSave: function(formData) {
      this.bulletinData.unshift(formData)
    },
    handleUpdate: function(formData) {
      this.bulletinData = this.bulletinData.map(bull => (bull._id === formData._id ? formData : bull))
    },
    showAddBulletin: async function(formData) {
      if (!formData) formData || {}
      this.$refs.bulletinAdd.show({ formData, bulletinsType: this.bulletinsType })
    },
  },
}
</script>
<style scpoed>
.bulletin {
  position: fixed;
  top: 60px;
  left: 18px;
  width: calc(100vw - 36px);
  height: calc(100vh - 60px);
  overflow: auto;
  z-index: 1;
}
</style>
